export default function composeClassNames(classes) {
	const classNames = classes.filter(Boolean);
	return classNames.join(' ');
}
